import { render, staticRenderFns } from "./Hours.vue?vue&type=template&id=54236b0e"
import script from "./Hours.vue?vue&type=script&lang=ts"
export * from "./Hours.vue?vue&type=script&lang=ts"
import style0 from "./Hours.vue?vue&type=style&index=0&id=54236b0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports